import { useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

export default function useGetOrganizationData(organizationId) {
  const [organization, setOrganization] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchOrganization = async () => {
      try {
        if (!organizationId) return;

        const orgRef = doc(db, 'organizations', organizationId);
        const orgSnap = await getDoc(orgRef);

        if (orgSnap.exists()) {
          setOrganization({
            id: orgSnap.id,
            ...orgSnap.data(), // Spread all document fields
          });
        } else {
          setError(new Error('Organization not found'));
        }
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);  
      }
    };

    fetchOrganization();
  }, [organizationId]);

  return { organization, loading, error };
}